import StorageObjective from './StorageObjective';
export default StorageObjective;
